import PropTypes from 'prop-types';
import { EventFilters } from '../UI/EventFilters/EventFilters';
import { WhatsOnGenreEvents } from './WhatsOnGenreEvents/WhatsOnGenreEvents';
import { EventFiltersProvider } from '../Shared/EventFiltersProvider';
import './WhatsOnGenre.scss';

export const WhatsOnGenre = (props) => (
  <EventFiltersProvider {...props} itemsPerPage={10} pageType={2}>
    <EventFilters {...props} />
    <WhatsOnGenreEvents />
  </EventFiltersProvider>
);

export const WhatsOnGenreSC = (props) => {
  const { sitecoreData } = props;
  return <WhatsOnGenre {...sitecoreData} />;
};

WhatsOnGenreSC.propTypes = {
  sitecoreData: PropTypes.object,
};

WhatsOnGenre.propTypes = {
  FilterSet: PropTypes.array,
  GenreId: PropTypes.string,
  FiltersActive: PropTypes.bool,
  SortByActive: PropTypes.bool,
};
